import type { CopyShape } from "../../intl";

import type { ROLE_LABELS_COPY_PT_BR } from "../roles.copy";

export const ROLE_LABELS_COPY_EN_US: CopyShape<typeof ROLE_LABELS_COPY_PT_BR> =
  {
    "org:owner": "Tãmi Creator",
    "org:admin": "Organization Manager",
    "org:commercial": "Deal Wrangler",
    "org:planner": "Post Keeper",
    "org:commercial_planner": "Official Jack of All Trades",
  };
